import { useEffect } from 'react'

const APP_SCHEME = 'com.freshaapp://reset-password'

const buildAppDeepLink = () => {
  const hash = window.location.hash ? window.location.hash.substring(1) : ''
  const search = window.location.search ? window.location.search.substring(1) : ''
  const params = new URLSearchParams(hash || search)

  const accessToken = params.get('access_token')
  const refreshToken = params.get('refresh_token')
  const type = params.get('type') || 'recovery'
  const code = params.get('code')
  const tokenHash = params.get('token_hash')

  if (accessToken && refreshToken) {
    return (
      `${APP_SCHEME}?access_token=${encodeURIComponent(accessToken)}` +
      `&refresh_token=${encodeURIComponent(refreshToken)}` +
      `&type=${encodeURIComponent(type)}`
    )
  }
  if (tokenHash) {
    return (
      `${APP_SCHEME}?token_hash=${encodeURIComponent(tokenHash)}` +
      `&type=${encodeURIComponent(type)}`
    )
  }
  if (code) {
    return `${APP_SCHEME}?code=${encodeURIComponent(code)}&type=recovery`
  }
  if (search) return `${APP_SCHEME}?${search}`
  if (hash) return `${APP_SCHEME}?${hash}`
  return APP_SCHEME
}

const AppResetPasswordBridge = () => {
  useEffect(() => {
    window.location.replace(buildAppDeepLink())
  }, [])

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-6 text-center text-gray-600">
      <p>Opening TimeLessTrends app...</p>
    </div>
  )
}

export default AppResetPasswordBridge
